import { handleError } from "../../../../utils/helpers";
import { QueryParams } from "../../../../utils/types";
import { adminBaseApi } from "../../../api";
import { PurchaseStatisticsResponse } from "../../payment/payment.types";

export const adminUsersApi = adminBaseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    adminGetPurchaseStatistics: builder.query<
      PurchaseStatisticsResponse,
      { eventId: string; otherParams?: QueryParams }
    >({
      query: (params) => {
        return {
          url: `payments/summary/${params.eventId}`,
          method: "GET",
          params: params.otherParams,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const { useAdminGetPurchaseStatisticsQuery } = adminUsersApi;
